// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"a40f3790","787":"28aecd2f"}[chunkId] + ".chunk.js";
};